"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomFilterUtils = exports.CUSTOM_FILTER_FIELDS = void 0;
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var FILTER_ID_LENGTH = 10;
var FILTER_ID_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
var FILTER_ID_PREFIX = 'pr-custom-';
exports.CUSTOM_FILTER_FIELDS = {
    EVAL_SCOPE: FILTER_ID_PREFIX + 'eval-scope',
    RELATIONSHIP: 'Q_TS_RS',
    SOURCE_ID: FILTER_ID_PREFIX + 'source-id',
    UNSOL_EVAL: 'Q_TS_UNSOL'
};
var CustomFilterUtils = /** @class */ (function () {
    function CustomFilterUtils() {
    }
    /**
     * Constructs a 10-digit random Id based on alphanumeric characters and a given prefix
     * @return {string} the new id
     */
    CustomFilterUtils.prototype.constructFilterId = function () {
        var filterId = FILTER_ID_PREFIX;
        for (var i = 0; i < FILTER_ID_LENGTH; ++i) {
            var randomIndex = Math.floor(Math.random() * FILTER_ID_CHARS.length);
            filterId += FILTER_ID_CHARS.charAt(randomIndex);
        }
        return filterId;
    };
    /**
     * Determines whether the given id is an custom filter id
     * @param  {string} id
     * @return {Boolean}
     */
    // @ts-ignore
    CustomFilterUtils.prototype.isCustomFilterId = function (id) {
        return lodash_1.default.isString(id) && lodash_1.default.startsWith(id, FILTER_ID_PREFIX);
    };
    /**
     * Checks if the given filter is a pr custom filter.
     * This is any filter that includes filter with a field that starts with 'prField'.
     */
    // @ts-ignore
    CustomFilterUtils.prototype.isCustomFilter = function (filter) {
        return this.checkFilterHelper(filter, lodash_1.default.values(exports.CUSTOM_FILTER_FIELDS));
    };
    /**
     * Checks if the given filter is a relationship filter.
     * This is any filter that includes filter with a Q_TS_RS field.
     */
    // @ts-ignore
    CustomFilterUtils.prototype.isRelationshipFilter = function (filter) {
        return this.checkFilterHelper(filter, [exports.CUSTOM_FILTER_FIELDS.RELATIONSHIP]);
    };
    CustomFilterUtils.prototype.isUnsolicitedEvalFilter = function (filter) {
        return this.checkFilterHelper(filter, [exports.CUSTOM_FILTER_FIELDS.UNSOL_EVAL]);
    };
    /**
     * CHecks if the given filters is valid
     * @param  {Object}  filter
     * @return {Boolean}
     */
    // @ts-ignore
    CustomFilterUtils.prototype.isValidFilter = function (filter) {
        return !!(filter && (filter.filter || (filter.children && filter.type)));
    };
    /**
     * Check if a filter that includes filter with a field included in a fields array.
     */
    // @ts-ignore
    // @ts-ignore
    // @ts-ignore
    CustomFilterUtils.prototype.checkFilterHelper = function (filter, fields) {
        var _this = this;
        if (!lodash_1.default.isObject(filter)) {
            // sanity check
            return false;
        }
        filter = filter;
        if (lodash_1.default.get(filter, 'filter.filter') || lodash_1.default.get(filter, 'filter.children')) {
            // initial call
            return this.checkFilterHelper(filter.filter, fields);
        }
        else if (filter.children) {
            // intermediate call
            return lodash_1.default.some(filter.children, function (child) {
                return _this.checkFilterHelper(child, fields);
            });
        }
        else {
            // base case
            var field = lodash_1.default.get(filter, 'filter.field', '');
            return lodash_1.default.includes(fields, field);
        }
    };
    return CustomFilterUtils;
}());
exports.CustomFilterUtils = CustomFilterUtils;
(function (module) {
    module.factory('pr.customFilterUtils', [
        function () { return new CustomFilterUtils(); }
    ]);
})(angular_1.module('qualtrics.pr'));
